function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.94509 5.87065L10.291 3.63424L4.60059 1.00101V0L11.2013 3.00541C11.4497 3.11858 11.609 3.36623 11.609 3.6385C11.609 3.90319 11.4587 4.14516 11.2207 4.26259L5.94509 6.86504V5.87065Z",
  fill: "#0092A7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.11874 10.3369L0.517591 7.34423C0.269644 7.23201 0.110352 6.98483 0.110352 6.71256C0.110352 6.44739 0.261584 6.20543 0.500048 6.08941L5.87048 3.47229V4.4733L1.42878 6.72298L7.11922 9.34295V10.3369H7.11874Z",
  fill: "#0092A7"
});

var SvgFluvIcon = function SvgFluvIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFluvIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fluv_icon.b2edb2fb.svg";
export { ForwardRef as ReactComponent };